import React from "react";
import { Image as ImageIcon, Loader2, Trash2 } from "lucide-react";
import { resolveImageUrl } from "@/lib/api";
import { UploadControls, useImageUploads } from "@/components/UploadControls";
import { SampleBadge } from "@/components/ImageLibrary";

// Universal single-image input: Gallery / Camera / Upload File / URL. onChange(url) gets a permanent URL.
export default function ImageInput({ value, onChange, label = "Image", testid = "image-input", disabled = false, libraryCategory, librarySuggest }) {
  const up = useImageUploads((urls) => onChange(urls[0]));
  return (
    <div data-testid={`${testid}-wrap`}>
      <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">{label}</label>
      {value ? (
        <div className="mt-2 relative inline-block">
          <img src={resolveImageUrl(value)} alt="" className="w-24 h-24 sm:w-28 sm:h-28 rounded-xl object-cover border border-slate-200 bg-slate-100" onError={(e) => { e.currentTarget.src = resolveImageUrl(""); }} data-testid={`${testid}-preview`} />
          <SampleBadge url={value} className="absolute bottom-1 left-1" testid={`${testid}-sample-badge`} />
          <button type="button" onClick={() => onChange("")} disabled={disabled || up.busy} className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-white border border-rose-200 text-rose-600 hover:bg-rose-50 shadow flex items-center justify-center disabled:opacity-60" aria-label="Remove image" data-testid={`${testid}-remove`}>
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      ) : (
        <div className="mt-2 w-24 h-24 sm:w-28 sm:h-28 rounded-xl border-2 border-dashed border-slate-200 bg-slate-50 flex items-center justify-center text-slate-400">
          {up.busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <ImageIcon className="w-5 h-5" />}
        </div>
      )}
      <UploadControls onFiles={(f) => up.run(f.slice(0, 1))} onUrl={(u) => onChange(u)} libraryCategory={libraryCategory} librarySuggest={librarySuggest} busy={up.busy} progress={up.progress} failed={up.failed} onRetry={up.retry} disabled={disabled} testid={testid} />
    </div>
  );
}
